export default __webpack_public_path__ + "static/media/blast.5f6189d5.png";